import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("as_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    if (token) localStorage.setItem("as_token", token);
    if (u) localStorage.setItem("as_user", JSON.stringify(u));
    setUser(u);
  };

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("as_token")) return;
    try {
      const { data } = await api.get("/auth/me");
      persist(null, data);
    } catch {
      logout();
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data.token, data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      persist(data.token, data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => {
    localStorage.removeItem("as_token");
    localStorage.removeItem("as_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, setUser: (u) => persist(null, u) }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
